module.exports = __webpack_public_path__ + "static/opengrantsLogo-a80dac05e6b3d4e13f156c7426230a5a.png";